export const PACE_PRO_SPLIT = 'PACE_PRO_SPLIT';
export const RUN_ACTIVE = 'RUN_ACTIVE';
export const RUN_REST = 'RUN_REST';
export const CLIMB_PRO_SPLIT = 'CLIMB_PRO_CYCLING_CLIMB';
export const CLIMB_PRO_SEGMENT = 'CLIMB_PRO_CYCLING_CLIMB_SECTION';
export const POWER_GUIDANCE_SPLIT = 'POWER_GUIDANCE_SPLIT';
export const WINDSURF_ACTIVE = 'WINDSURF_ACTIVE';
export const RWD_STAND = 'RWD_STAND';
export const RWD_WALK = 'RWD_WALK';
export const RWD_RUN = 'RWD_RUN';
export const OBSTACLE = 'OBSTACLE';
export const INTERVAL_WARMUP = 'INTERVAL_WARMUP';
export const INTERVAL_ACTIVE = 'INTERVAL_ACTIVE';
export const INTERVAL_COOLDOWN = 'INTERVAL_COOLDOWN';
export const SURF_ACTIVE = 'SURF_ACTIVE';
export const ASCENT_SPLIT = 'ASCENT_SPLIT'; //BC Ski 2.0
export const DESCENT_SPLIT = 'DESCENT_SPLIT'; //BC Ski 2.0
export const TRANSITION = 'TRANSITION';
export const ROUND_ACTIVE = 'ROUND_ACTIVE'; // Gaming Matches
export const ROUND_REST = 'ROUND_REST'; // Gaming Matches
export const SWIM_STRAIGHTNESS = 'SWIM_STRAIGHTNESS';
export const SKI_LIFT_SPLIT = 'SKI_LIFT_SPLIT';
export const SKI_RUN_SPLIT = 'SKI_RUN_SPLIT';
export const SKI_RUN_SPLIT_SECTION = 'SKI_RUN_SPLIT_SECTION';
export const SURFACE_TYPE_PAVED = 'SURFACE_TYPE_PAVED';
export const SURFACE_TYPE_UNPAVED = 'SURFACE_TYPE_UNPAVED';
export const DIVE = 'DIVE';
export const DYNAMIC_APNEA_DIVE = 'DYNAMIC_APNEA_DIVE';
export const DYNAMIC_APNEA_STA = 'DYNAMIC_APNEA_STA';
export const DYNAMIC_APNEA_REST = 'DYNAMIC_APNEA_REST';
export const STATIC_APNEA = 'STATIC_APNEA';
export const DOWNHILL_BIKING_RUN_SPLIT = 'DOWNHILL_RUN';
export const DOWNHILL_BIKING_LIFT_SPLIT = 'DOWNHILL_LIFT';
export const TIMING_GATE = 'TIMING_GATE';
export const TIMING_RUN = 'TIMING_RUN';

/**
 * Replaces the "Compatible Split Types for Runs" array to allow for Role Keys/Feature Flags to be
 * checked for new features.
 * @param {Object} roleKeys - an object of feature flags for adding hidden splits
 */
export const getCompatibleSplitsForRuns = (roleKeys = null) => {
    // these are the already public splits not hidden behind a feature flag, can reuse this for feature flags later
    let publicCompatibleSplits = [
        WINDSURF_ACTIVE,
        DOWNHILL_BIKING_RUN_SPLIT,
        ASCENT_SPLIT,
        DESCENT_SPLIT,
        SKI_RUN_SPLIT
    ];

    return publicCompatibleSplits;
};

/**
 * Mappers for Split Types and their Values for Charts
 */
export const RUN_WALK_CHART_VALUE_MAPPER = {
    RWD_STAND: 100,
    RWD_WALK: 67,
    RWD_RUN: 33
};

export const POOL_APNEA_INTERVALS_CHART_VALUE_MAPPER = {
    DYNAMIC_APNEA_DIVE: 0,
    DYNAMIC_APNEA_STA: 33,
    DYNAMIC_APNEA_REST: 100
};

/**
 * Following is to associate which layers to show for Metrics Tracklog
 * depending on which TypedSplits the activity contains.
 * Used in ActivityPageView.js, and associated with
 * MAP_METRIC_LAYERS_TYPED_SPLITS in ActivitiesUtil.js
 */
export const RUN_WALK = 'RUN_WALK';
export const ASCENT_DESCENT = 'ASCENT_DESCENT';
export const RUN_LIFT = 'RUN_LIFT';
export const PAVED_UNPAVED = 'PAVED_UNPAVED';
export const DOWNHILL_RUN_LIFT = 'DOWNHILL_RUN_LIFT';
export const COMPATIBLE_MAP_METRIC_LAYERS_TYPED_SPLITS = {
    RWD_STAND: { layerToShow: RUN_WALK },
    RWD_WALK: { layerToShow: RUN_WALK },
    RWD_RUN: { layerToShow: RUN_WALK },
    OBSTACLE: { layerToShow: OBSTACLE },
    ASCENT_SPLIT: { layerToShow: ASCENT_DESCENT },
    DESCENT_SPLIT: { layerToShow: ASCENT_DESCENT },
    TRANSITION: { layerToShow: ASCENT_DESCENT },
    SKI_RUN_SPLIT: { layerToShow: RUN_LIFT },
    SKI_LIFT_SPLIT: { layerToShow: RUN_LIFT },
    SURFACE_TYPE_PAVED: { layerToShow: PAVED_UNPAVED },
    SURFACE_TYPE_UNPAVED: { layerToShow: PAVED_UNPAVED },
    DOWNHILL_RUN: { layerToShow: DOWNHILL_RUN_LIFT },
    DOWNHILL_LIFT: { layerToShow: DOWNHILL_RUN_LIFT }
};

export const SKI_DIFFICULTY_VALUES = {
    GREEN: { value: 'ski_difficulty_green', difficulty: 1 },
    BLUE: { value: 'ski_difficulty_blue', difficulty: 2 },
    RED: { value: 'ski_difficulty_red', difficulty: 3 },
    BLACK: { value: 'ski_difficulty_black', difficulty: 4 },
    DOUBLE_BLACK: { value: 'ski_difficulty_double_black', difficulty: 5 },
    ORANGE: { value: 'ski_difficulty_orange', difficulty: 6 }
};
